/**
 * HECAM Forms Webhook Submission Handler (Web3Forms)
 */

export default (() => {
  const submitUrl = 'https://api.web3forms.com/submit'
  const contactAccessKey = 'f05b41fd-605d-43ca-a6a9-d727fcde1d15'
  const ruckrufAccessKey = 'b5fe619e-5191-4827-9334-05a9b651a864'

  // Main Contact Form
  const contactForm = document.getElementById('contact-form')
  if (contactForm) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault()

      if (!contactForm.checkValidity()) {
        e.stopPropagation()
        contactForm.classList.add('was-validated')
        return
      }

      const submitBtn = contactForm.querySelector('button[type="submit"]')
      const originalBtnText = submitBtn.innerHTML
      submitBtn.disabled = true
      submitBtn.innerHTML = `
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Senden...
      `

      // Get values
      const vorname = contactForm.querySelector('#contact-vorname').value
      const nachname = contactForm.querySelector('#contact-nachname').value
      const unternehmen =
        contactForm.querySelector('#contact-unternehmen').value ||
        'Nicht angegeben'
      const position =
        contactForm.querySelector('#contact-position').value ||
        'Nicht angegeben'
      const email = contactForm.querySelector('#contact-email').value
      const telefon =
        contactForm.querySelector('#contact-telefon').value || 'Nicht angegeben'
      const anliegen = contactForm.querySelector('#contact-anliegen').value
      const nachricht = contactForm.querySelector('#contact-nachricht').value

      // Format payload for Web3Forms
      const payload = {
        access_key: contactAccessKey,
        subject: '📩 Neue Kontaktanfrage (HECAM)',
        from_name: 'HECAM Website',
        Name: `${vorname} ${nachname}`,
        'E-Mail': email,
        Telefon: telefon,
        Unternehmen: unternehmen,
        Position: position,
        Anliegen: anliegen,
        Nachricht: nachricht,
      }

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
          throw new Error('Fehler beim Senden')
        }

        // Show success message inside the form container
        const formParent = contactForm.parentElement
        formParent.innerHTML = `
          <div class="text-center py-5">
            <div class="mb-4">
              <i class="fi-check-circle text-primary display-4 d-inline-block"></i>
            </div>
            <h3 class="text-white h4 mb-3">Vielen Dank für deine Nachricht!</h3>
            <p class="text-body-secondary px-3 mb-4">Wir haben deine Anfrage erhalten und werden uns so schnell wie möglich bei dir melden.</p>
            <button class="btn btn-light rounded-pill px-4" onclick="window.location.reload()">Zurück zum Formular</button>
          </div>
        `
      } catch (error) {
        console.error('Submission error:', error)
        alert(
          'Es gab ein Problem beim Senden deiner Nachricht. Bitte versuche es später noch einmal oder kontaktiere uns direkt per E-Mail.'
        )
        submitBtn.disabled = false
        submitBtn.innerHTML = originalBtnText
      }
    })
  }

  // Callback Modal Form
  const handleRuckrufSubmit = async (formElement) => {
    if (!formElement.checkValidity()) {
      formElement.classList.add('was-validated')
      return
    }

    const submitBtn = formElement.querySelector('button[type="submit"]')
    const originalBtnText = submitBtn.innerHTML
    submitBtn.disabled = true
    submitBtn.innerHTML = `
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Senden...
    `

    // Get values
    const name = formElement.querySelector('#ruckruf-name').value
    const company = formElement.querySelector('#ruckruf-company').value
    const phone = formElement.querySelector('#ruckruf-phone').value
    const zeit = formElement.querySelector('#ruckruf-zeit').value
    const nachricht =
      formElement.querySelector('#ruckruf-nachricht').value || 'Keine Nachricht'

    // Format payload for Web3Forms
    const payload = {
      access_key: ruckrufAccessKey,
      subject: '📞 Rückruf anfordern (HECAM)',
      from_name: 'HECAM Website',
      Name: name,
      Telefon: phone,
      Unternehmen: company,
      Wunschzeit: zeit,
      'Nachricht / Thema': nachricht,
    }

    try {
      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })

      const result = await response.json()

      if (!response.ok || !result.success) {
        throw new Error('Fehler beim Senden')
      }

      // Show success message inside the modal
      const modalContent = formElement.closest('.modal-content')
      if (modalContent) {
        modalContent.innerHTML = `
          <div class="modal-body text-center py-5">
            <i class="fi-check-circle text-primary display-4 mb-3 d-inline-block"></i>
            <h4 class="text-white">Vielen Dank!</h4>
            <p class="text-body-secondary px-4">Wir haben deine Rückrufanfrage erhalten und melden uns zum gewünschten Zeitpunkt bei dir.</p>
            <button type="button" class="btn btn-sm btn-primary mt-3 px-4 animate-scale" data-bs-dismiss="modal">Schließen</button>
          </div>
        `
      }
    } catch (error) {
      console.error('Submission error:', error)
      alert(
        'Es gab ein Problem beim Senden deiner Rückrufanfrage. Bitte versuche es später noch einmal.'
      )
      submitBtn.disabled = false
      submitBtn.innerHTML = originalBtnText
    }
  }

  // We set up event delegation or dynamic attachment so that even if forms load dynamically,
  // or on DOMContentLoaded, we attach the listener.
  document.addEventListener('submit', (e) => {
    if (e.target && e.target.id === 'ruckrufForm') {
      e.preventDefault()
      handleRuckrufSubmit(e.target)
    }
  })
})()
